import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, LinearProgress } from "@mui/material";

import usePageAttachmentTabs from "../Hooks/usePageAttachmentTabs";
import { useReports } from "../Components/ReportPage/new-report-page/hooks/useGetReportPage";
import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
// eslint-disable-next-line unused-imports/no-unused-imports
import Footer from "../Components/common/footer";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import PageDocsTab from "../Components/DocPage/new-tab/page-docs-tab";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
// import TabsClient from "../Components/new-client-dashboard/Tabs";
// import ActionBarImg from "../assets/images/incident-folder-icon-color.svg";
import ReportTab from "../Components/ReportPage/new-report-page/report-tab";
import NewReportModal from "../Components/ReportPage/ReportModals/NewReportModal";
import { fetchPageObject, fetchShakespeareStatus, getCaseId, getClientId } from "../Utils/helper";
import { api_without_cancellation } from "../api/api";
import DatesIcon from "../assets/images/dates.svg";
import DetailIcon from "../assets/images/detail.svg";
import ReportSummaryTable from "../Components/ReportPage/new-report-page/ReportSummaryTable";
// import PanelActionBarComponent from "../Components/common/PanelActionBarComponent";
// import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
// import MoreChangesTab from "../Components/new-client-dashboard/MoreChangesTab";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";
import PlaceHolderifNothingAdded from "../Components/components-new-final/placeholder-nothing-added";
import addIconGold from "../assets/Add-icon-gold.svg";

const PageContent = ({ currentPage, reports, refetch, isDummy, view }) => {
  // Map of tab ids to their labels for filtering
  // const reportTypeLabels = {
  //   "auto-accident": "Auto Accident Report",
  //   "food-safety": "Food Safety Report",
  //   "premises-accident": "Premises Accident Report",
  // };
  // Filter reports based on currentPage
  const filteredReports = useMemo(() => {
    if (currentPage === "all" || currentPage === "photo") {
      return reports;
    }
    // Filter reports by report_type_name matching the label for the current tab

    return reports?.filter((report) => report.report_type_name === currentPage) || [];
  }, [currentPage, reports]);

  // Determine which component to render based on view
  const ReportComponent = view === "summary" ? ReportSummaryTable : ReportTab;

  switch (currentPage) {
    // case "all":
    //   return <ReportComponent reports={filteredReports} fetchReports={refetch} isDummy={isDummy} />;
    // case "auto-accident":
    // case "food-safety":
    // case "premises-accident":
    //   return <ReportComponent reports={filteredReports} fetchReports={refetch} isDummy={isDummy} />;
    case "photo":
      return <PhotoTab pageId={14} pageName={"Reports"} />;
    default:
      return <ReportComponent reports={filteredReports} fetchReports={refetch} isDummy={isDummy} />;
  }
};

const NewReportPage = () => {
  const [currentPage, setCurrentPage] = useState("all");
  const [showReportModal, setShowReportModal] = useState(false);
  const [isDummy, setIsDummy] = useState(false);
  const { reports, isReportTaken, showReportTakenField, refetch, loading } = useReports();
  const dispatch = useDispatch();
  const currentCaseId = getCaseId();
  const [view, setView] = useState("summary");
  const [pageObject, setPageObject] = useState(null);
  const isMediaPage = currentPage === "photo" || currentPage === "docs";

  useEffect(() => {
    if (currentCaseId && !pageObject) {
      fetchPageObject(currentCaseId, 14).then((data) => {
        setPageObject(data);
      });
    }
  }, [currentCaseId, pageObject]);

  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);
  async function fetchIsDummyStatus() {
    try {
      const response = await api_without_cancellation.get(
        `/api/general/panel_page_block/?case_id=${currentCaseId}&page_id=${14}`
      );
      setIsDummy(response?.data?.status);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchIsDummyStatus();

    fetchShakespeareStatus(currentCaseId, 14, dispatch);
  }, [currentCaseId, dispatch]);
  //
  const mainTabs = useMemo(() => {
    // const allReportTypes = [
    //   {
    //     id: "auto-accident",
    //     label: "Auto Accident Report",
    //   },
    //   {
    //     id: "food-safety",
    //     label: "Food Safety Report",
    //   },
    //   {
    //     id: "premises-accident",
    //     label: "Premises Accident Report",
    //   },
    // ];

    // const availableReportTypes = allReportTypes.filter((reportType) =>
    //   reports?.some((report) => report.report_type_name === reportType.label)
    // );

    const tabs = [];

    tabs.push({
      id: "all",
      label: "All",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("all"),
      leftHand: false,
    });

    const seen = new Set();

    reports.forEach((reportType) => {
      const name = reportType.report_type_name;
      if (!name || seen.has(name)) return;
      seen.add(name);

      tabs.push({
        id: name,
        label: name,
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange(name),
        leftHand: false,
      });
    });

    return tabs;
  }, [handlePageChange, reports]);

  const viewTabs = useMemo(
    () => {
      const tabs = [
        {
          id: "summary",
          label: "Summary",
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-50)",
          activeColor: "white",
          onClick: () => {
            currentPage === "photo" && handlePageChange("all");
            setView("summary");
            handlePageChange("all");
          },
          leftHand: true,
          span: (
            <span
              style={{
                width: "15px",
                height: "15px",
              }}
              className="fw-bold d-flex align-items-center justify-content-center  text-gold"
            >
              <img
                src={DatesIcon}
                style={{
                  width: "15px",
                  height: "15px",
                }}
                alt="Detail"
              />
            </span>
          ),
        },
        {
          id: "detailed",
          label: "Detailed",
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-50)",
          activeColor: "white",
          onClick: () => {
            currentPage === "photo" && handlePageChange("all");
            setView("detailed");
            handlePageChange("all");
          },
          leftHand: true,
          span: (
            <span
              style={{
                width: "15px",
                height: "15px",
              }}
              className="fw-bold d-flex align-items-center justify-content-center  text-gold"
            >
              <img
                src={DetailIcon}
                style={{
                  width: "15px",
                  height: "15px",
                }}
                alt="Detail"
              />
            </span>
          ),
        },
      ];

      return tabs;
    },
    [isDummy, currentPage, reports] // Dependency array includes isdummy to trigger recomputation when isdummy changes
  );

  const buttonTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "add-report",
      label: "Report",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      activeColor: "white",
      left: "0px",
      onClick: () => setShowReportModal(true),
      leftHand: true,
      span: (
        <span className="fw-bold ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    });

    return tabs;
  }, [isDummy]);

  const photoTabs = useMemo(
    () => [
      {
        id: "docs",
        label: "Docs",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("docs"),
        leftHand: true,
        span: (
          <span className="fw-bold ic-15 d-flex align-items-center">
            <img
              src="https://simplefirm-bucket.s3.amazonaws.com/static/images/documents-icon-color_b6TvcB7.svg"
              width={15}
              height={15}
              alt=""
            />
          </span>
        ),
      },
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              }
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      },
    ],
    []
  );
  const attachmentTabs = usePageAttachmentTabs(14, photoTabs);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);
  const adjustReportColumnWidths = () => {
    const pinColumn = (selector) => {
      const cols = document.querySelectorAll(selector);
      if (!cols.length) return;

      let maxWidth = 0;
      cols.forEach((col) => {
        maxWidth = Math.max(maxWidth, col.getBoundingClientRect().width);
      });
      cols.forEach((col) => {
        col.style.width = `${maxWidth}px`;
        col.style.minWidth = `${maxWidth}px`;
      });
    };

    pinColumn(".report-type-name");
    pinColumn(".agency-name");
    pinColumn(".phone-col");
    pinColumn(".cost-col");
    pinColumn(".completed-col");
    pinColumn(".ordered-col");
    pinColumn(".received-col");
  };

  useEffect(() => {
    adjustReportColumnWidths();
    window.addEventListener("resize", adjustReportColumnWidths);
    return () => window.removeEventListener("resize", adjustReportColumnWidths);
  }, [reports, view]);
  // eslint-disable-next-line no-console
  console.log("Reports Data on Prod ===>", reports);
  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="14" />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            {/* <div className="d-flex align-items-center">
              <div style={{ minWidth: "45%", justifyContent: "flex-start" }}>
                <NewChangesTabs
                  currentTab={currentPage}
                  tabsData={mainTabs}
                  height={25}
                  labelClass=" justify-content-start"
                />
              </div>

              <div
                style={{ minWidth: "25%", justifyContent: "flex-start" }}
                className=" justify-content-start"
              >
                <MoreChangesTab
                  currentTab={view}
                  tabsData={viewTabs}
                  height={25}
                  labelClass=" justify-content-start p-l-5"
                />
              </div>

              <div
                style={{ minWidth: "15%", justifyContent: "flex-start" }}
                className=" justify-content-start"
              >
                <MoreChangesTab
                  currentTab={showReportModal}
                  tabsData={buttonTabs}
                  height={25}
                  labelClass=" justify-content-start p-l-5"
                />
              </div>

              <div style={{ width: "15%", position: "relative", right: "208px" }}>
                <MoreChangesTab
                  currentTab={currentPage}
                  tabsData={attachmentTabs}
                  height={25}
                  labelClass="p-l-5 p-r-5 justify-content-end"
                />
              </div>
            </div> */}
            <SmartResponsiveTabsContainer
              isEmpty={isDummy || (!loading && reports.length === 0)}
              HandlePage={currentPage}
              tabsData={mainTabs}
              viewTab={viewTabs}
              viewTabControlled={true}
              addTab={buttonTabs}
              photoTab={attachmentTabs}
              photoTabControlled={true}
              handlePageChange={handlePageChange}
              viewType={isMediaPage ? null : view}
            />
            {loading && (
              <Box sx={{ width: "100%", paddingTop: "15px", paddingBottom: "15px" }}>
                <LinearProgress
                  sx={{
                    backgroundColor: "#8C9AAF", // Background track color
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#19395f", // Progress bar color
                    },
                  }}
                />
              </Box>
            )}
            {!loading && reports.length === 0 && !isDummy && !isMediaPage && (
              <>
                {/* <div className="d-flex align-items-center justify-content-center">
                  <div
                    className="placeholder-panel px-5 py-1"
                    // style={{ width: "372px" }}
                    onClick={() => setShowReportModal(true)}
                  >
                    <span className="text-center text-uppercase font-weight-semibold">
                      No Reports Added to the Case.
                    </span>
                    <span className="text-center text-uppercase font-weight-semibold">
                      Click to Add.
                    </span>
                  </div>
                </div> */}
                <PlaceHolderifNothingAdded
                  text1={"No Reports Added to the Case"}
                  text2={"Click to Add"}
                  pageIcon={pageObject?.page_icon}
                  onClick={() => setShowReportModal(true)}
                />
              </>
            )}
            {!loading && reports.length === 0 && isDummy && !isMediaPage && (
              <>
                {/* <div className="d-flex align-items-center justify-content-center">
                  <div
                    className="placeholder-panel px-5 py-1"
                    // style={{ width: "372px" }}
                    onClick={() => setShowReportModal(true)}
                  >
                    <span className="text-center text-uppercase font-weight-semibold">
                      No Reports Added to the Case.
                    </span>
                    <span className="text-center text-uppercase font-weight-semibold">
                      Click to Add.
                    </span>
                  </div>
                </div> */}
                <PlaceHolderifNothingAdded
                  text1={"No Reports on Case"}
                  text2={"Page is Marked Complete"}
                  text3={"To Add a Report to the Case Click Here"}
                  pageIcon={pageObject?.page_icon}
                  completed
                  onClick={() => setShowReportModal(true)}
                />
              </>
            )}
            {!loading && reports.length > 0 && !isDummy && !isMediaPage && (
              <>
                <PageContent
                  currentPage={currentPage}
                  reports={reports}
                  refetch={() => {
                    fetchIsDummyStatus();
                    refetch();
                  }}
                  isDummy={isDummy}
                  view={view}
                />
              </>
            )}

            {!loading && currentPage === "docs" && (
              <PageDocsTab
                key={`${getClientId()}-${currentCaseId}`}
                pageId={14}
                pageName={pageObject?.name}
                pageIcon={pageObject?.page_icon}
              />
            )}

            {!loading && currentPage === "photo" && (
              <>
                <PageContent
                  currentPage={currentPage}
                  reports={reports}
                  refetch={() => {
                    fetchIsDummyStatus();
                    refetch();
                  }}
                  isDummy={isDummy}
                  view={view}
                />
              </>
            )}

            <NotesSectionDashboard pageName={"Reports"} />
          </div>
        </div>
      </div>

      <Footer />

      {showReportModal && (
        <NewReportModal
          show={showReportModal}
          handleClose={() => setShowReportModal(false)}
          isReoportTaken={isReportTaken}
          fetchReports={() => {
            fetchIsDummyStatus();
            refetch();
          }}
          isDummy={isDummy}
          showReportTakenField={showReportTakenField}
        />
      )}
    </>
  );
};

export default React.memo(NewReportPage);
